import React, { useState } from 'react';
import { executeKakaoShare } from '../../utils/kakaoShare';

// `rightExtra` is an optional React node rendered on the far right of the row.
// Used for example by the case detail modal to slot a "3분 셀프견적" floater
// next to the kakao/copy buttons.
const ShareButton = ({ url, title, description, imageUrl, rightExtra }) => {
    const [copied, setCopied] = useState(false);
    const shareUrl = url || window.location.href;
    const handleKakaoShare = async () => {
        await executeKakaoShare({ url: shareUrl, title, description, imageUrl });
    };

    const handleCopyUrl = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = shareUrl;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '1.5rem', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <button
                onClick={handleKakaoShare}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#FEE500',
                    border: 'none',
                    cursor: 'pointer',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    transition: 'transform 0.1s'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                title="카카오톡 공유"
            >
                {/* Kakao Standard Icon SVG */}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#000000" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 3C6.48 3 2 6.36 2 10.5C2 13.04 3.51 15.28 5.82 16.59L4.85 20.14C4.76 20.5 5.16 20.78 5.48 20.59L9.69 17.82C10.43 17.94 11.2 18 12 18C17.52 18 22 14.64 22 10.5C22 6.36 17.52 3 12 3Z" />
                </svg>
            </button>

            <button
                onClick={handleCopyUrl}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#F3F4F6',
                    border: '1px solid #E5E7EB',
                    cursor: 'pointer',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    transition: 'all 0.1s',
                    position: 'relative'
                }}
                onMouseOver={(e) => { e.currentTarget.style.transform = 'scale(1.05)'; e.currentTarget.style.backgroundColor = '#E5E7EB'; }}
                onMouseOut={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.backgroundColor = '#F3F4F6'; }}
                title="URL 복사"
            >
                {/* Link Icon SVG */}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4B5563" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                </svg>

                {copied && (
                    <div style={{
                        position: 'absolute',
                        bottom: '120%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: '#1F2937',
                        color: 'white',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        whiteSpace: 'nowrap',
                        fontWeight: '500',
                        animation: 'fadeInOut 2s forwards'
                    }}>
                        복사완료!
                    </div>
                )}
            </button>
            {rightExtra && (
                <div style={{ marginLeft: 'auto' }}>{rightExtra}</div>
            )}
            <style>{`
                @keyframes fadeInOut {
                    0% { opacity: 0; transform: translate(-50%, 5px); }
                    10% { opacity: 1; transform: translate(-50%, 0); }
                    80% { opacity: 1; transform: translate(-50%, 0); }
                    100% { opacity: 0; transform: translate(-50%, -5px); }
                }
            `}</style>
        </div>
    );
};

export default ShareButton;
